﻿import { observer } from '../main.js';

window.addEventListener('load', () => {
    const $objects = document.querySelectorAll('.is-observed');

    $objects.forEach(($object) => {
        observer.observe($object);
    });
});